import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import { Card, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { UserCog, ArrowLeft } from 'lucide-react';
import SurveyorManagement from '../../components/admin/SurveyorManagement';

const AdminSurveyorsPage = () => {
  const navigate = useNavigate();
  
  return (
    <Layout>
      <div className="page-transition">
        <Button
          variant="ghost"
          onClick={() => navigate('/admin/content')}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Content Management
        </Button>
        
        <Card className="mb-6">
          <CardHeader className="bg-gradient-to-r from-[#F59E0B]/5 to-white">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-[#F59E0B] rounded-lg">
                <UserCog className="w-6 h-6 text-white" />
              </div>
              <div>
                <CardTitle className="text-2xl">Surveyor Management</CardTitle>
                <CardDescription>Manage surveyors by department, grades and MMDs</CardDescription>
              </div>
            </div>
          </CardHeader>
        </Card>
        
        <SurveyorManagement />
      </div>
    </Layout>
  );
};

export default AdminSurveyorsPage;
